import { zString } from '@/form/zod.utils';
import z from 'zod';

export const filterAnalysisSampleKitSchema = z
  .object({
    fastqcStatus: zString.optional(),
    hasProfileName: z.boolean().optional(),
  })
  .partial();
